<template>
  <div class="sc__product">
    <div class="sc__product__image-wrapper">
      <img
        class="sc__product__image"
        :src="productImage"
        :alt="productName"
      >
    </div>

    <div class="sc__product__info-wrapper">
      <h2 class="sc__product__name">
        <!-- eslint-disable vue/no-v-html -->
        <a
          href="#"
          v-html="productName"
        />
        <!-- eslint-enable vue/no-v-html -->
      </h2>
    </div>
  </div>
</template>

<script src="./index.js"></script>

<style scoped lang="scss" src="./style.scss"></style>
